import { createAction } from '@reduxjs/toolkit';

import type { GuardResponse } from './RouteGuard.props';

export const accessDenied = createAction<GuardResponse>('guard/accessDenied');
